import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_SITE_TRACKER,
	TOGGLE_SITE_TRACKER_DIALOG,
	GET_SITE_TRACKER_DETAILS,
	GET_SITE_TRACKER_ATTACHMENTS,
	GET_SITE_TRACKER_DROPDOWNS,
	GET_SITES_IDS,
	TOGGLE_DELETE_SITE_TRACKER_DIALOG,
	GET_SITE_TRACKER_AUTOCOMPLETE,
	TOGGLE_ATTACH_FILES_DIALOG,
	TOGGLE_DELETE_ATTACHMENTS_DIALOG,
	TOGGLE_DELETE_ATTACHMENT_DIALOG,
	TOGGLE_OPTIONS_DIALOG,
	TOGGLE_OPTIONS_FORM,
	TOGGLE_FILE_UPDATE_SITES_DIALOG,
	TOGGLE_IMPORT_VALIDATIONS_DIALOG,
	TOGGLE_UPDATE_DIALOG,
	TOGGLE_UPDATE_CONFIRMATION,
	TOGGLE_EXPORT_SITES_BY_TYPE_DIALOG,
	GET_COMMENTS,
	ADD_DROPDOWN_FIELD,
	GET_VISIBLE_COLUMNS,
	GET_VISIBLE_FILTERS,
	FILE_UPDATE_SITES_MESSAGE,
	GET_ALL_UPLOAD_INFO,
	TOGGLE_EXPORT_BY_DEPENDENCIES_DIALOG,
	IMPORT_DEPENDENCIES_MANUAL_DATA_MESSAGE,
} from '../actions/SiteTrackerActions';

const initialState = {
	sites: [],
	SiteTrackerDialogVisibility: false,
	siteDetails: [],
	dropdowns: [],
	sitesIds: [],
	siteTrackerDto: [],
	tableId: '',
	deleteSiteTrackerDialogVisibility: false,
	attachFileSiteTrackerDialogVisibility: false,
	removeFileSiteTrackerDialogVisibility: false,
	optionsSiteTrackerDialogVisibility: false,
	optionsSiteTrackerFormVisibility: false,
	siteTrackerUpdateConfirmationVisibility: false,
	fileUpdateSitesSiteTrackerDialogVisibility: false,
	importValidationsSiteTrackerDialogVisibility: false,
	exportSitesByTypeDialogVisibility: false,
	fileUpdateSitesMessage: '',
	dropdownLabel: '',
	dropdownName: '',
	dropdownValue: '',
	dropdownId: undefined,
	fieldType: '',
	fieldTypeValue: '',
	fieldName: '',
	fieldValue: '',
	phase: '',
	autocompleteFields: [],
	comments: [],
	newDropdownField: '',
	exportSitesByDependenciesDialogVisibility: false,
	importDependenciesManualDataMessage: '',
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const siteTrackerReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_SITE_TRACKER: {
						return {
							...state,
							sites: action.sites
						};
					}
					case TOGGLE_SITE_TRACKER_DIALOG: {
						return {
							...state,
							SiteTrackerDialogVisibility: action.visible,
							tableId: action.tableId,
							formState: initialState.formState
						};
					}
					case GET_SITE_TRACKER_DETAILS: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.siteDetails }
							}
						};
					}
					case GET_SITE_TRACKER_ATTACHMENTS: {
						return {
							...state,
							attachments: action.attachments
						};
					}
					case GET_SITE_TRACKER_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case GET_SITES_IDS: {
						return {
							...state,
							sitesIds: action.sitesIds
						};
					}
					case TOGGLE_DELETE_SITE_TRACKER_DIALOG: {
						return {
							...state,
							deleteSiteTrackerDialogVisibility: action.visible,
							tableId: action.tableId
						};
					}
					case GET_SITE_TRACKER_AUTOCOMPLETE: {
						return {
							...state,
							autocompleteFields: action.autocompleteFields
						};
					}
					case TOGGLE_ATTACH_FILES_DIALOG: {
						return {
							...state,
							attachFileSiteTrackerDialogVisibility: action.visible,
							attachFileSiteTrackerDialogTableId: action.tableId,
							attachFileSiteTrackerDialogTitle: action.title
						};
					}
					case TOGGLE_DELETE_ATTACHMENTS_DIALOG: {
						return {
							...state,
							removeFileSiteTrackerDialogVisibility: action.visible,
							removeFileSiteTrackerDialogTableId: action.tableId,
							removeFileSiteTrackerDialogTitle: action.title
						};
					}
					case TOGGLE_DELETE_ATTACHMENT_DIALOG: {
						return {
							...state,
							deleteAttachmentDialogVisibility: action.visible,
							deleteAttachmentDialogTableId: action.tableId,
							deleteAttachmentDialogId: action.id,
						};
					}
					case TOGGLE_OPTIONS_DIALOG: {
						return {
							...state,
							optionsSiteTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_OPTIONS_FORM: {
						return {
							...state,
							optionsSiteTrackerFormVisibility: action.visible,
							dropdownLabel: action.dropdownLabel,
							dropdownName: action.dropdownName,
							dropdownValue: action.dropdownValue,
							dropdownId: action.dropdownId
						};
					}
					case TOGGLE_FILE_UPDATE_SITES_DIALOG: {
						return {
							...state,
							fileUpdateSitesSiteTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_IMPORT_VALIDATIONS_DIALOG: {
						return {
							...state,
							importValidationsSiteTrackerDialogVisibility: action.visible
						};
					}
					case FILE_UPDATE_SITES_MESSAGE: {
						return {
							...state,
							fileUpdateSitesMessage: action.fileUpdateSitesMessage
						};
					}
					case TOGGLE_UPDATE_DIALOG: {
						return {
							...state,
							updateSiteTrackerDialogVisibility: action.visible
						};
					}
					case TOGGLE_EXPORT_SITES_BY_TYPE_DIALOG: {
						return {
							...state,
							exportSitesByTypeDialogVisibility: action.visible
						};
					}
					case TOGGLE_UPDATE_CONFIRMATION: {
						return {
							...state,
							siteTrackerUpdateConfirmationVisibility: action.visible,
							fieldType: action.fieldType,
							fieldTypeValue: action.fieldTypeValue,
							fieldName: action.fieldName,
							fieldValue: action.fieldValue,
							phase: action.phase
						};
					}
					case GET_COMMENTS: {
						return {
							...state,
							comments: action.comments
						};
					}
					case ADD_DROPDOWN_FIELD: {
						return {
							...state,
							newDropdownField: action.newDropdownField
						};
					}
					case GET_VISIBLE_COLUMNS: {
						return {
							...state,
							visibleColumns: action.visibleColumns
						};
					}
					case GET_VISIBLE_FILTERS: {
						return {
							...state,
							visibleFilters: action.visibleFilters
						};
					}
					case GET_ALL_UPLOAD_INFO: {
						return {
							...state,
							allUploadInfo: action.allUploadInfo
						};
					}
					case TOGGLE_EXPORT_BY_DEPENDENCIES_DIALOG: {
						return {
							...state,
							exportSitesByDependenciesDialogVisibility: action.visible
						};
					}
					case IMPORT_DEPENDENCIES_MANUAL_DATA_MESSAGE: {
						return {
							...state,
							importDependenciesManualDataMessage: action.importDependenciesManualDataMessage
						};
					}
					default: {
						return state;
					}
	}
};

export default siteTrackerReducer;
